/** Delete and focus callbacks for task mutations. */
import { useCallback } from 'react';
import { getCurrentDateAndTime } from '@/utils/timeUtils';

export function useTaskDeleteAndFocusCallbacks({
  taskTree,
  getAllDescendantIds,
  handleDeleteTask,
  startFocus,
  updateTask,
}) {
  const deleteTask = useCallback(
    async (taskId, _userId) => {
      const descendantIds = getAllDescendantIds(taskId, taskTree);
      return handleDeleteTask([taskId, ...descendantIds]);
    },
    [handleDeleteTask, taskTree, getAllDescendantIds],
  );

  const handleStartFocus = useCallback(
    async (taskId, userId) => {
      if (!userId || !startFocus) return;
      startFocus(taskId);
      const { date, time } = getCurrentDateAndTime();
      await updateTask(taskId, { date, time, status: 'Active' }, userId);
    },
    [startFocus, updateTask],
  );

  return { deleteTask, handleStartFocus };
}
